import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';

import NotificationPreferences from './notificationPreferences';

const enhance = compose(
  withNamespaces(['common', 'chat']),
);
export default enhance(NotificationPreferences);
